export default __webpack_public_path__ + "static/media/logo2.ffcb9476.png";